class DmOrderConfirmed extends HTMLElement {
  connectedCallback() {
    const root = this.querySelector('[data-dm-confirm-root]');
    if (!root) return; // signed-out state — static fallback markup only

    const dataEl = this.querySelector('[data-dm-orders]');
    const orders = dataEl ? JSON.parse(dataEl.textContent) : [];
    const wanted = new URLSearchParams(window.location.search).get('order');
    const normalize = (name) => (name || '').replace(/^#/, '').trim().toLowerCase();
    const order = wanted ? orders.find((o) => normalize(o.name) === normalize(wanted)) : null;

    const found = this.querySelector('[data-dm-confirm-found]');
    const fallback = this.querySelector('[data-dm-confirm-fallback]');

    if (!order) {
      found.hidden = true;
      fallback.hidden = false;
      return;
    }

    fallback.hidden = true;
    found.hidden = false;
    this.#render(order);
  }

  #statusIndex(order) {
    if (order.shipmentStatus === 'delivered') return 3;
    if (order.fulfillmentStatus === 'fulfilled') return 2;
    if (['in_transit', 'out_for_delivery', 'label_printed', 'ready_for_pickup'].includes(order.shipmentStatus)) return 2;
    return 1;
  }

  #render(order) {
    const idx = this.#statusIndex(order);

    this.querySelector('[data-dm-confirm-number]').textContent = order.name;

    this.querySelectorAll('[data-dm-confirm-steps] [data-step]').forEach((el, i) => {
      el.classList.remove('is-done', 'is-current');
      if (i < idx) el.classList.add('is-done');
      else if (i === idx) el.classList.add('is-current');
    });

    this.querySelector('[data-dm-confirm-fill]').style.width = `${(idx / 3) * 100}%`;

    const eta = this.querySelector('[data-dm-confirm-eta]');
    eta.textContent = order.city
      ? `On its way to ${order.city}.`
      : 'We’ll update this as your order moves.';
  }
}

customElements.define('dm-order-confirmed', DmOrderConfirmed);
